import { FormEvent } from 'react';
import { QrcodeCoupon } from '../../types/qrcode';
import { Form, FormField, FormLabel, FormInput, FormCheckbox, Button } from '../ui';
import { FormPhone } from '../ui/FormControls';

interface QrcodeCouponFormProps {
  coupon: QrcodeCoupon | null;
  onSubmit: (e: FormEvent<HTMLFormElement>) => void;
  isLoading: boolean;
  onClose: () => void;
}

function QrcodeCouponForm({ coupon, onSubmit, isLoading, onClose }: QrcodeCouponFormProps) {
  return (
    <Form onSubmit={onSubmit}>
      <FormField>
        <FormLabel htmlFor="phone">Telefone</FormLabel>
        <FormPhone id="phone" name="phone" value={coupon?.phone || ''} onChange={() => {}} />
      </FormField>

      <FormField>
        <div className="flex items-center">
          <FormCheckbox
            id="processed"
            name="processed"
            defaultChecked={coupon?.processed || false}
          />
          <FormLabel htmlFor="processed" className="ml-2 mb-0">
            Processado
          </FormLabel>
        </div>
      </FormField>

      {coupon?.coupon_uid && (
        <FormField>
          <FormLabel htmlFor="coupon_uid">ID do Cupom</FormLabel>
          <FormInput id="coupon_uid" value={coupon.coupon_uid} readOnly className="bg-gray-50" />
        </FormField>
      )}

      <div className="mt-5 sm:mt-6 sm:grid sm:grid-flow-row-dense sm:grid-cols-2 sm:gap-3">
        <Button type="submit" isLoading={isLoading} className="sm:col-start-2">
          {coupon ? 'Salvar' : 'Criar'}
        </Button>
        <Button type="button" variant="secondary" onClick={onClose} className="sm:col-start-1">
          Cancelar
        </Button>
      </div>
    </Form>
  );
}

export default QrcodeCouponForm;
